import React, { useState, useEffect } from 'react';
import { PlusCircle, Pencil, Ban, CheckCircle, Trash2 } from 'lucide-react';//Trash2
import { useNavigate } from 'react-router-dom';
import { parse, format, isValid } from 'date-fns';

const UserMailList = () => {
    const [userProfile, setUsersProfile] = useState([]);
    const navigate = useNavigate();
    const BUId = sessionStorage.getItem('BUId');

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const userResponse = await fetch(`${process.env.REACT_APP_API_URL}/Login/GetBUDetails?BUId=${BUId}`);

                if (!userResponse.ok) {
                    throw new Error('Failed to fetch data');
                }

                const data = await userResponse.json();

                setUsersProfile(data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchUserData();
    }, [BUId]);


    //   const handleEditUser = (user, mailDetail) => {
    //     const userData = {
    //       ...user,
    //       ...mailDetail  // Spread the mail details
    //     };
    //     console.log("Combined user data:", userData);
    //     navigate('/AddMail', { state: { userData: userData } });
    //   };

    //   const handleAddUser = () => {
    //     navigate('/AddMail');
    //   };

    // const handleDeleteClick = (userId) => {
    //   setSelectedUserId(userId);
    //   setShowDeleteModal(true);
    // };

    // const handleDeleteUser = () => {
    //   setUsersProfile(userProfile.filter(user => user.id !== selectedUserId));
    //   setShowDeleteModal(false);
    //   setSelectedUserId(null);
    // };

    // Log FormData contents before sending the request
    // const logFormData = (formData) => {
    //   const formDataEntries = {};
    //   formData.forEach((value, key) => {
    //     formDataEntries[key] = value;
    //   });
    //   console.log('FormData contents:', formDataEntries);  
    // };

    const handleBlockUser = async (BUId, buMailId, currentStatus) => {
        try {
            const body = {
                BUId: BUId,
                BUMailId: buMailId,
                IsActive: !currentStatus,
            };

            const response = await fetch(`${process.env.REACT_APP_API_URL}/Login/UpdateBUMailStatus`, {
                method: 'PUT',
                body: JSON.stringify(body),
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                const errorText = await response.text();
                console.error('Error Response:', errorText);
                throw new Error('Failed to update user status');
            }

            const updatedData = await response.json();
            console.log('Response from backend:', updatedData);

            setUsersProfile(prevState =>
                prevState.map(user => ({
                    ...user,
                    buDetails: user.buDetails.map(detail =>
                        detail.buMailId === buMailId
                            ? {
                                ...detail,
                                isActive: !currentStatus,
                            }
                            : detail
                    ),
                }))
            );
        } catch (error) {
            console.error('Error updating user status:', error);
        }
    };
    const parseCustomDate = (dateString) => {
        if (!dateString) return null;

        const formats = [
            'dd-MM-yyyy HH:mm:ss',
            'MM/dd/yyyy hh:mm:ss a',
            'dd/MM/yyyy hh:mm:ss a'
        ];

        for (const formatStr of formats) {
            const parsedDate = parse(dateString, formatStr, new Date());
            if (isValid(parsedDate)) {
                return parsedDate;
            }
        }

        return null;
    };

    const formatCustomDate = (date) => {
        if (!date || !isValid(date)) return 'Invalid Date';
        return format(date, 'dd/MM/yyyy hh:mm a');
    };




    return (
        <div className="p-8">
            {/* Header */}
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold">BUSINESS UNIT DETAILS</h1>
                {/* <button
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
          onClick={handleAddUser}
        >
          <PlusCircle className="h-4 w-4" />
          Add New
        </button> */}
            </div>

            {/* Table */}
            <div className="w-full overflow-x-auto bg-white rounded-lg shadow">
                <table className="w-full">
                    <thead className="bg-gradient-to-r from-blue-500 to-purple-600">
                        <tr>
                            <th className="px-6 py-3 text-left text-sm font-semibold text-white">BU Name</th>
                            <th className="px-6 py-3 text-left text-sm font-semibold text-white">Email</th>
                            <th className="px-6 py-3 text-left text-sm font-semibold text-white">MailType</th>
                            <th className="px-6 py-3 text-left text-sm font-semibold text-white">Host</th>
                            <th className="px-6 py-3 text-left text-sm font-semibold text-white">Port</th>
                            {/* <th className="px-6 py-3 text-left text-sm font-semibold text-gray-600">UserName</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-600">Password</th> */}
                            <th className="px-6 py-3 text-left text-sm font-semibold text-white">Status</th>
                            <th className="px-6 py-3 text-left text-sm font-semibold text-white">Created On</th>
                            {/* <th className="px-6 py-3 text-left text-sm font-semibold text-white">Actions</th> */}
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                        {userProfile.length > 0 ? (
                            userProfile.map((user, index) => (
                                // Loop through each item in the buDetails array
                                user.buDetails.map((detail, detailIndex) => (
                                    <tr key={`${index}-${detailIndex}`} className="hover:bg-gray-50">
                                        <td className="px-6 py-4 text-sm text-gray-900">{user.buName}</td>
                                        <td className="px-6 py-4 text-sm text-gray-900">{detail.buMailId}</td>
                                        <td className="px-6 py-4 text-sm text-gray-900">{detail.mailType}</td>
                                        <td className="px-6 py-4 text-sm">{detail.host}</td>
                                        <td className="px-6 py-4 text-sm">{detail.port}</td>
                                        {/* <td className="px-6 py-4 text-sm">{detail.netUserName}</td>
          <td className="px-6 py-4 text-sm">{detail.netPassword}</td> */}
                                        <td className="px-6 py-4 text-sm">
                                            <span
                                                className={`inline-flex px-2 py-1 rounded-full text-xs font-semibold ${detail.isActive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                                                    }`}
                                            >
                                                {detail.isActive ? 'Active' : 'InActive'}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 text-sm text-gray-900">  {formatCustomDate(parseCustomDate(detail.createdOn))}</td>
                                        {/* <td className="px-6 py-4">
            <div className="flex gap-2">
              <button
                className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
                onClick={() => handleEditUser(user, detail)}
              >
                <Pencil className="h-4 w-4 text-gray-600" />
              </button>
              <button
                className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
                onClick={() => {

                  handleBlockUser(user.buId, detail.buMailId, detail.isActive);
                }}
              >
                {detail.isActive ? (
                  <Ban className="h-4 w-4 text-gray-600" />
                ) : (
                  <CheckCircle className="h-4 w-4 text-green-600" />
                )}
              </button>
            </div>
          </td> */}
                                    </tr>
                                ))
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" className="px-6 py-4 text-sm text-center text-gray-600">No users found</td>
                            </tr>
                        )}
                    </tbody>


                </table>
            </div>


        </div>
    );
};

export default UserMailList;
